// extracted by mini-css-extract-plugin
export var dropdownContainer = "_5t-5";
export var imageContainer = "_5t-4";
export var metricsGrid = "_5t-2";
export var productDetailContainer = "_5t-1";
export var productListContainer = "_5t-0";
export var subscriberTableContainer = "_5t-3";